/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/delivery/service.proto" (package "rd.api.delivery", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { DeliveryService } from "./service_pb";
import type { OptimizeDeliveryStopsRes } from "./service_pb";
import type { OptimizeDeliveryStopsReq } from "./service_pb";
import type { GetScannedDeliveryRes } from "./service_pb";
import type { GetScannedDeliveryReq } from "./service_pb";
import type { GetDeliveryStopPDFRes } from "./service_pb";
import type { GetDeliveryStopPDFReq } from "./service_pb";
import type { EmailDeliveryPDFRes } from "./service_pb";
import type { EmailDeliveryPDFReq } from "./service_pb";
import type { GetDeliveryPDFRes } from "./service_pb";
import type { GetDeliveryPDFReq } from "./service_pb";
import type { RemoveSaleFromDeliveryRes } from "./service_pb";
import type { RemoveSaleFromDeliveryReq } from "./service_pb";
import type { RemoveSaleFromStopRes } from "./service_pb";
import type { RemoveSaleFromStopReq } from "./service_pb";
import type { MoveStagedSaleToStopRes } from "./service_pb";
import type { MoveStagedSaleToStopReq } from "./service_pb";
import type { AttachSaleToDeliveryRes } from "./service_pb";
import type { AttachSaleToDeliveryReq } from "./service_pb";
import type { UnstageSaleRes } from "./service_pb";
import type { UnstageSaleReq } from "./service_pb";
import type { StageSaleRes } from "./service_pb";
import type { StageSaleReq } from "./service_pb";
import type { UpdateDeliveryStopRes } from "./service_pb";
import type { UpdateDeliveryStopReq } from "./service_pb";
import type { UpdateDeliveryRes } from "./service_pb";
import type { UpdateDeliveryReq } from "./service_pb";
import type { CreateDeliveryRes } from "./service_pb";
import type { CreateDeliveryReq } from "./service_pb";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetDeliveryRes } from "./service_pb";
import type { GetDeliveryReq } from "./service_pb";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service rd.api.delivery.DeliveryService
 */
export interface IDeliveryServiceClient {
    /**
     * @generated from protobuf rpc: GetDelivery
     */
    getDelivery(input: GetDeliveryReq, options?: RpcOptions): UnaryCall<GetDeliveryReq, GetDeliveryRes>;
    /**
     * @generated from protobuf rpc: CreateDelivery
     */
    createDelivery(input: CreateDeliveryReq, options?: RpcOptions): UnaryCall<CreateDeliveryReq, CreateDeliveryRes>;
    /**
     * @generated from protobuf rpc: UpdateDelivery
     */
    updateDelivery(input: UpdateDeliveryReq, options?: RpcOptions): UnaryCall<UpdateDeliveryReq, UpdateDeliveryRes>;
    /**
     * @generated from protobuf rpc: UpdateDeliveryStop
     */
    updateDeliveryStop(input: UpdateDeliveryStopReq, options?: RpcOptions): UnaryCall<UpdateDeliveryStopReq, UpdateDeliveryStopRes>;
    /**
     * @generated from protobuf rpc: StageSale
     */
    stageSale(input: StageSaleReq, options?: RpcOptions): UnaryCall<StageSaleReq, StageSaleRes>;
    /**
     * @generated from protobuf rpc: UnstageSale
     */
    unstageSale(input: UnstageSaleReq, options?: RpcOptions): UnaryCall<UnstageSaleReq, UnstageSaleRes>;
    /**
     * @generated from protobuf rpc: AttachSaleToDelivery
     */
    attachSaleToDelivery(input: AttachSaleToDeliveryReq, options?: RpcOptions): UnaryCall<AttachSaleToDeliveryReq, AttachSaleToDeliveryRes>;
    /**
     * @generated from protobuf rpc: MoveStagedSaleToStop
     */
    moveStagedSaleToStop(input: MoveStagedSaleToStopReq, options?: RpcOptions): UnaryCall<MoveStagedSaleToStopReq, MoveStagedSaleToStopRes>;
    /**
     * @generated from protobuf rpc: RemoveSaleFromStop
     */
    removeSaleFromStop(input: RemoveSaleFromStopReq, options?: RpcOptions): UnaryCall<RemoveSaleFromStopReq, RemoveSaleFromStopRes>;
    /**
     * @generated from protobuf rpc: RemoveSaleFromDelivery
     */
    removeSaleFromDelivery(input: RemoveSaleFromDeliveryReq, options?: RpcOptions): UnaryCall<RemoveSaleFromDeliveryReq, RemoveSaleFromDeliveryRes>;
    /**
     * @generated from protobuf rpc: GetDeliveryPDF
     */
    getDeliveryPDF(input: GetDeliveryPDFReq, options?: RpcOptions): UnaryCall<GetDeliveryPDFReq, GetDeliveryPDFRes>;
    /**
     * @generated from protobuf rpc: EmailDeliveryPDF
     */
    emailDeliveryPDF(input: EmailDeliveryPDFReq, options?: RpcOptions): UnaryCall<EmailDeliveryPDFReq, EmailDeliveryPDFRes>;
    /**
     * @generated from protobuf rpc: GetDeliveryStopPDF
     */
    getDeliveryStopPDF(input: GetDeliveryStopPDFReq, options?: RpcOptions): UnaryCall<GetDeliveryStopPDFReq, GetDeliveryStopPDFRes>;
    /**
     * @generated from protobuf rpc: GetScannedDelivery
     */
    getScannedDelivery(input: GetScannedDeliveryReq, options?: RpcOptions): UnaryCall<GetScannedDeliveryReq, GetScannedDeliveryRes>;
    /**
     * @generated from protobuf rpc: OptimizeDeliveryStops
     */
    optimizeDeliveryStops(input: OptimizeDeliveryStopsReq, options?: RpcOptions): UnaryCall<OptimizeDeliveryStopsReq, OptimizeDeliveryStopsRes>;
}
/**
 * @generated from protobuf service rd.api.delivery.DeliveryService
 */
export class DeliveryServiceClient implements IDeliveryServiceClient, ServiceInfo {
    typeName = DeliveryService.typeName;
    methods = DeliveryService.methods;
    options = DeliveryService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetDelivery
     */
    getDelivery(input: GetDeliveryReq, options?: RpcOptions): UnaryCall<GetDeliveryReq, GetDeliveryRes> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDeliveryReq, GetDeliveryRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateDelivery
     */
    createDelivery(input: CreateDeliveryReq, options?: RpcOptions): UnaryCall<CreateDeliveryReq, CreateDeliveryRes> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateDeliveryReq, CreateDeliveryRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateDelivery
     */
    updateDelivery(input: UpdateDeliveryReq, options?: RpcOptions): UnaryCall<UpdateDeliveryReq, UpdateDeliveryRes> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateDeliveryReq, UpdateDeliveryRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateDeliveryStop
     */
    updateDeliveryStop(input: UpdateDeliveryStopReq, options?: RpcOptions): UnaryCall<UpdateDeliveryStopReq, UpdateDeliveryStopRes> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateDeliveryStopReq, UpdateDeliveryStopRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: StageSale
     */
    stageSale(input: StageSaleReq, options?: RpcOptions): UnaryCall<StageSaleReq, StageSaleRes> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<StageSaleReq, StageSaleRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UnstageSale
     */
    unstageSale(input: UnstageSaleReq, options?: RpcOptions): UnaryCall<UnstageSaleReq, UnstageSaleRes> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<UnstageSaleReq, UnstageSaleRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AttachSaleToDelivery
     */
    attachSaleToDelivery(input: AttachSaleToDeliveryReq, options?: RpcOptions): UnaryCall<AttachSaleToDeliveryReq, AttachSaleToDeliveryRes> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<AttachSaleToDeliveryReq, AttachSaleToDeliveryRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: MoveStagedSaleToStop
     */
    moveStagedSaleToStop(input: MoveStagedSaleToStopReq, options?: RpcOptions): UnaryCall<MoveStagedSaleToStopReq, MoveStagedSaleToStopRes> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<MoveStagedSaleToStopReq, MoveStagedSaleToStopRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoveSaleFromStop
     */
    removeSaleFromStop(input: RemoveSaleFromStopReq, options?: RpcOptions): UnaryCall<RemoveSaleFromStopReq, RemoveSaleFromStopRes> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveSaleFromStopReq, RemoveSaleFromStopRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoveSaleFromDelivery
     */
    removeSaleFromDelivery(input: RemoveSaleFromDeliveryReq, options?: RpcOptions): UnaryCall<RemoveSaleFromDeliveryReq, RemoveSaleFromDeliveryRes> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveSaleFromDeliveryReq, RemoveSaleFromDeliveryRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetDeliveryPDF
     */
    getDeliveryPDF(input: GetDeliveryPDFReq, options?: RpcOptions): UnaryCall<GetDeliveryPDFReq, GetDeliveryPDFRes> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDeliveryPDFReq, GetDeliveryPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EmailDeliveryPDF
     */
    emailDeliveryPDF(input: EmailDeliveryPDFReq, options?: RpcOptions): UnaryCall<EmailDeliveryPDFReq, EmailDeliveryPDFRes> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<EmailDeliveryPDFReq, EmailDeliveryPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetDeliveryStopPDF
     */
    getDeliveryStopPDF(input: GetDeliveryStopPDFReq, options?: RpcOptions): UnaryCall<GetDeliveryStopPDFReq, GetDeliveryStopPDFRes> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDeliveryStopPDFReq, GetDeliveryStopPDFRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetScannedDelivery
     */
    getScannedDelivery(input: GetScannedDeliveryReq, options?: RpcOptions): UnaryCall<GetScannedDeliveryReq, GetScannedDeliveryRes> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetScannedDeliveryReq, GetScannedDeliveryRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: OptimizeDeliveryStops
     */
    optimizeDeliveryStops(input: OptimizeDeliveryStopsReq, options?: RpcOptions): UnaryCall<OptimizeDeliveryStopsReq, OptimizeDeliveryStopsRes> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<OptimizeDeliveryStopsReq, OptimizeDeliveryStopsRes>("unary", this._transport, method, opt, input);
    }
}
